import { render } from "./QuestionnaireCompleted.vue?vue&type=template&id=79673836&scoped=true"
import script from "./QuestionnaireCompleted.vue?vue&type=script&lang=js"
export * from "./QuestionnaireCompleted.vue?vue&type=script&lang=js"

import "./QuestionnaireCompleted.vue?vue&type=style&index=0&id=79673836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79673836"]])

export default __exports__